export { default as ParcelTrackingEnrouteViewPage } from "./enroute-view-page";
